import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { AmericanWageringGateway } from './american-wagering-gateway';
import { v4 as uuid } from 'uuid';
import { getLogger } from '@williamhill/rosi-ui-shared/src/lib/logger-plus';
import { DynamicConfig } from './dynamic-config';

const logger = getLogger('bet-tracker/services/gateway-provider');

export type Services =
  | {
      loading: true;
      deviceId?: string;
      americanWageringGateway?: undefined;
      dynamicConfig?: undefined;
    }
  | {
      loading: false;
      deviceId: string;
      americanWageringGateway: AmericanWageringGateway;
      dynamicConfig: DynamicConfig;
    };

export const ServicesContext = createContext<Services>({ loading: true });

export function ServicesProviderContext({ children }: { children: ReactNode }) {
  const [state, setState] = useState<Services>({ loading: true });

  useEffect(() => {
    createAmericanWageringGateway();
  }, []);

  return <ServicesContext.Provider value={state}>{children}</ServicesContext.Provider>;

  async function createAmericanWageringGateway() {
    try {
      const deviceId = getOrCreateDeviceId();
      const gateway = new AmericanWageringGateway({ uniqueDeviceId: deviceId });
      await gateway.waitForDynamicConfig();
      setState({
        loading: false,
        americanWageringGateway: gateway,
        deviceId,
        dynamicConfig: gateway.getDynamicConfig()
      });
    } catch (error) {
      logger.error({ error }, 'Failed to initialise services.');
    }
  }
}

export function useServices(): Services {
  return useContext(ServicesContext);
}

function getOrCreateDeviceId(): string {
  let deviceId = localStorage.getItem('BET_TRACKER_DEVICE_ID');
  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem('BET_TRACKER_DEVICE_ID', deviceId);
  }
  return deviceId;
}
